module.exports = __webpack_public_path__ + "static/media/clinician-blood-thinner-table-preview@2x.29bc41ef.png";